const config = {
  REACT_APP_TENANT: null,
  ...process.env,
  generalError:
    'There was a problem in connecting to the server. Please check your internet and try again.',
};

export default config;
